var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"file",staticClass:"input-file",attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.handleFileUpload()}}}),_vm._v(" "+_vm._s(_vm.$i18n.t('CarregarLogo'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }